import { useState, useEffect } from "react";
import SideMenu from "../components/SideMenu";
import Header from "../components/Header";
import UserMenu from "../components/UserMenu";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import API_BASE_URL from "../utilities/ApiConfig";
import { v4 as uuidv4 } from "uuid";
import {
  resetPartyDetails,
  setFirstPartyDetails,
  setWitnessDetails,
} from "../redux-store/slices/AttendanceSlice";
import { useLocation, useNavigate } from "react-router-dom";
import loadercrs from "../assets/images/loadercrs.gif";
import { toast } from "react-toastify";
import REPORT_BASE_URL from "../utilities/ReportConfig";

const NewReceipt = () => {
  const [currentDate, setCurrentDate] = useState("");
  const [cashReceiptData, setCashReceiptData] = useState("");
  const [fromYear, setFromYear] = useState("");
  const [toYear, setToYear] = useState("");
  const [selectedYears, setSelectedYears] = useState(0);
  const [bookNo, setBookNo] = useState("");
  const [fee, setFee] = useState("");
  const [searchType, setSearchType] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updateCashReceiptDetails, setUpdateCashReceiptData] = useState("");
  const [editMode, setEditMode] = useState(false);
  const dispatch = useDispatch();

  const [formData2, setFormData2] = useState({
    prtname: "",
    prt2name: "",
    property_detail: "",
    fee: "",
    option: "",
  });
  const [validationErrors, setValidationErrors] = useState({
    prtname: false,
    prt2name: false,
    property_detail: false,
    fee: false,
    option: false,
  });

  const [formData, setFormData] = useState({
    Name: "",
    relation: "",
    relativeName: "",
    occupation: "",
    address: "",
  });

  const [witnessFormData, setWitnessFormData] = useState({
    Name: "",
    relation: "",
    relativeName: "",
    occupation: "",
    address: "",
  });

  const [tableData, setTableData] = useState([]);
  const [witnessTableData, setWitnessTableData] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editId, setEditId] = useState(null);

  const [applicantName, setApplicantName] = useState("");
  const [relation, setRelation] = useState("");
  const [relativeName, setRelativeName] = useState("");
  const [occupation, setOccupation] = useState("");
  const [address, setAddress] = useState("");

  const [activeForm, setActiveForm] = useState("firstParty");

  console.log("tableData", tableData);
  const navigate = useNavigate();
  console.log("witnessTableData", witnessTableData);

  const location = useLocation();
  const { regYear, vol, sr, typeRecpt, mod } = location.state || {};
  console.log("updateCashReceiptDetails", updateCashReceiptDetails);
  console.log("cashReceiptData", cashReceiptData);

  const handleFormToggle = (form) => {
    setActiveForm(form);
    setValidationErrors({}); // Reset validation errors
  };
  console.log(formData2);

  const { userDetails } = useSelector((state) => state.auth);

  console.log("userDetails", userDetails.dcode);

  useEffect(() => {
    const today = new Date();
    const formattedDate = `${today.getDate()}/${
      today.getMonth() + 1
    }/${today.getFullYear()}`;
    setCurrentDate(formattedDate);
  }, []);

  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1949 }, (_, i) => 1950 + i);
  };
  const handleChanges = (e) => {
    debugger;
    const { id, value } = e.target;
    setFormData2((prev) => ({
      ...prev,
      [id]: value,
    }));
    setValidationErrors((prev) => ({
      ...prev,
      [id]: false,
    }));
  };
  const handleYearChange = () => {
    if (!fromYear || !toYear) return;

    const from = parseInt(fromYear, 10);
    const to = parseInt(toYear, 10);

    if (from > to) {
      alert("To year should not be less than From year.");
      setFromYear("");
      setToYear("");
      setFee("");
      setSelectedYears(0);
      return;
    }

    const yearsCount = to - from + 1;
    setSelectedYears(yearsCount);

    let calculatedFee = 0;

    if (bookNo === "3" || bookNo === "4") {
      calculatedFee = Math.min(5 * yearsCount, 100);
    } else if (searchType === "Ordinary") {
      calculatedFee = Math.min(5 * yearsCount, 25);
    } else if (searchType === "Urgent") {
      calculatedFee = 20 * yearsCount;
    } else if (searchType === "Most Urgent") {
      calculatedFee = 20 * yearsCount + 5;
    }

    setFee(calculatedFee);
  };

  const fetchCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/get_details_Virtual_Load_Cashreceipt_Sp/${userDetails.dcode}/${userDetails.srocode}/0/receipt_attendence`
      );

      if (response.data.statusResponse.statusCode === 200) {
        setCashReceiptData(response.data.cashReceiptDetails);
        setEditMode(false);
      } else {
        setError("No data found");
      }
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  const fetchUpdateCashReceiptDetails = async () => {
    try {
      const response = await axios.get(
        `${API_BASE_URL}/CashReceipt/GetReceiptModification/${userDetails.dcode}/${userDetails.srocode}/${vol}/${sr}/${regYear}`
      );

      setUpdateCashReceiptData(response.data[0]);
      setEditMode(true);
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    debugger;
    if (typeRecpt === "Miscelleneous" && mod === true) {
      fetchUpdateCashReceiptDetails();
    } else {
      fetchCashReceiptDetails();
    }
  }, [typeRecpt, mod]); // Dependency array ensures this runs when typeRecpt changes
  useEffect(() => {
    if (editMode && updateCashReceiptDetails) {
      setFormData2({
        prtname: updateCashReceiptDetails.appName || "",
        prt2name: updateCashReceiptDetails.deedType || "",
        property_detail: updateCashReceiptDetails.regNo || "",
        code: updateCashReceiptDetails.appliNo || "",
        tyear: updateCashReceiptDetails.defYear || "",
        fyear: updateCashReceiptDetails.regNo || "",

        token: updateCashReceiptDetails.page || "",
      });
      setFormData({
        fee: updateCashReceiptDetails.miscFee || "",
      });

      // setFee(updateCashReceiptDetails.miscFee || '');
    }
  }, [updateCashReceiptDetails, editMode]);
  const handleRadioChange = (event) => {
    debugger;
    setFormData2({ option: event.target.value });
  };

  useEffect(() => {
    const savedFirstPartyData =
      JSON.parse(sessionStorage.getItem("firstPartyTableData")) || [];
    const savedWitnessData =
      JSON.parse(sessionStorage.getItem("witnessTableData")) || [];

    if (savedFirstPartyData.length) {
      setTableData(savedFirstPartyData);
      dispatch(setFirstPartyDetails(savedFirstPartyData));
    }

    if (savedWitnessData.length) {
      setWitnessTableData(savedWitnessData);
      dispatch(setWitnessDetails(savedWitnessData));
    }
  }, [dispatch]);

  // const handleAdd = (e) => {
  //   e.preventDefault();
  //   const formDataToSave = activeForm === "firstParty" ? formData : witnessFormData;

  //   if (!formDataToSave.Name || !formDataToSave.relation || !formDataToSave.relativeName || !formDataToSave.occupation || !formDataToSave.address) {
  //     alert("Please fill all required fields.");
  //     return;
  //   }

  //   const tableToUpdate = activeForm === "firstParty" ? tableData : witnessTableData;

  //   // Generate sequential ID based on existing entries
  //   const prefix = activeForm === "firstParty" ? "01" : "03";
  //   const nextNumber = String(tableToUpdate.length + 1).padStart(2, "0");
  //   const generatedId = `${prefix}${nextNumber}`;

  //   const newData = {
  //     id: isEditing ? editId : generatedId,
  //     ...formDataToSave,
  //   };

  //   const updatedTableData = isEditing
  //     ? tableToUpdate.map((entry) => (entry.id === editId ? newData : entry))
  //     : [...tableToUpdate, newData];

  //   if (activeForm === "firstParty") {
  //     setTableData(updatedTableData);
  //     dispatch(setFirstPartyDetails(updatedTableData));
  //     sessionStorage.setItem("firstPartyTableData", JSON.stringify(updatedTableData));
  //   } else {
  //     setWitnessTableData(updatedTableData);
  //     dispatch(setWitnessDetails(updatedTableData));
  //     sessionStorage.setItem("witnessTableData", JSON.stringify(updatedTableData));
  //   }

  //   setFormData({ Name: "", relation: "", relativeName: "", occupation: "", address: "" });
  //   setWitnessFormData({ Name: "", relation: "", relativeName: "", occupation: "", address: "" });
  //   setEditId(null);
  //   setIsEditing(false);
  // };

  const handleAdd = (e) => {
    e.preventDefault();
    const formDataToSave =
      activeForm === "firstParty" ? formData : witnessFormData;

    // Validation logic
    const errors = {};
    if (!formDataToSave.Name) errors.Name = "Name is required";
    if (!formDataToSave.relation) errors.relation = "Relation is required";
    if (!formDataToSave.relativeName)
      errors.relativeName = "Relative Name is required";
    if (!formDataToSave.occupation)
      errors.occupation = "Occupation is required";
    if (!formDataToSave.address) errors.address = "Address is required";

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show the first error message
      return;
    }

    const tableToUpdate =
      activeForm === "firstParty" ? tableData : witnessTableData;

    // Generate sequential ID based on existing entries
    const prefix = activeForm === "firstParty" ? "01" : "03";
    const nextNumber = String(tableToUpdate.length + 1).padStart(2, "0");
    const generatedId = `${prefix}${nextNumber}`;

    const newData = {
      id: isEditing ? editId : generatedId,
      ...formDataToSave,
    };

    const updatedTableData = isEditing
      ? tableToUpdate.map((entry) => (entry.id === editId ? newData : entry))
      : [...tableToUpdate, newData];

    if (activeForm === "firstParty") {
      setTableData(updatedTableData);
      dispatch(setFirstPartyDetails(updatedTableData));
      sessionStorage.setItem(
        "firstPartyTableData",
        JSON.stringify(updatedTableData)
      );
    } else {
      setWitnessTableData(updatedTableData);
      dispatch(setWitnessDetails(updatedTableData));
      sessionStorage.setItem(
        "witnessTableData",
        JSON.stringify(updatedTableData)
      );
    }

    setFormData({
      Name: "",
      relation: "",
      relativeName: "",
      occupation: "",
      address: "",
    });
    setWitnessFormData({
      Name: "",
      relation: "",
      relativeName: "",
      occupation: "",
      address: "",
    });
    setEditId(null);
    setIsEditing(false);
  };
  const handleEdit = (id) => {
    const entryToEdit = (
      activeForm === "firstParty" ? tableData : witnessTableData
    ).find((entry) => entry.id === id);

    if (entryToEdit) {
      if (activeForm === "firstParty") {
        setFormData({
          Name: entryToEdit.Name,
          relation: entryToEdit.relation,
          relativeName: entryToEdit.relativeName,
          occupation: entryToEdit.occupation,
          address: entryToEdit.address,
        });
      } else {
        setWitnessFormData({
          Name: entryToEdit.Name,
          relation: entryToEdit.relation,
          relativeName: entryToEdit.relativeName,
          occupation: entryToEdit.occupation,
          address: entryToEdit.address,
        });
      }
      setEditId(id);
      setIsEditing(true);
    }
  };

  const handleDelete = (id) => {
    const updatedTableData = (
      activeForm === "firstParty" ? tableData : witnessTableData
    ).filter((entry) => entry.id !== id);

    if (activeForm === "firstParty") {
      setTableData(updatedTableData);
      dispatch(setFirstPartyDetails(updatedTableData));
      sessionStorage.setItem(
        "firstPartyTableData",
        JSON.stringify(updatedTableData)
      );
    } else {
      setWitnessTableData(updatedTableData);
      dispatch(setWitnessDetails(updatedTableData));
      sessionStorage.setItem(
        "witnessTableData",
        JSON.stringify(updatedTableData)
      );
    }

    // Reset form data if in editing mode and the entry is being deleted
    if (id === editId) {
      setFormData({
        Name: "",
        relation: "",
        relativeName: "",
        occupation: "",
        address: "",
      });
      setWitnessFormData({
        Name: "",
        relation: "",
        relativeName: "",
        occupation: "",
        address: "",
      });
      setEditId(null);
      setIsEditing(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (activeForm === "firstParty") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    } else {
      setWitnessFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
    setValidationErrors((prev) => ({
      ...prev,
      [name]: false, // Clear the validation error for this field
    }));
  };

  const CashReceiptReportLink = (printData) => {
    debugger;
    return `${REPORT_BASE_URL}/Report/CashReceiptReports.aspx?dcode=${
      userDetails.dcode
    }&srocode=${userDetails.srocode}&vol=${printData.vol}&sr=${
      printData.sr
    }&year=${
      printData.regYear
    }&recptDate=${currentDate}&tdate=${currentDate}&mode=receipt&mode1=${"Miscelleneous"}`;
  };
  const handleSave = async () => {
    const errors = {};

    if (!formData2.option) {
      errors.option = "Please Select Attendance either Objection";
    } else if (!formData2.prtname) {
      errors.prtname = "Please fill Applicant Name";
    } else if (!formData2.fee) {
      errors.fee = "Please fill fee";
    } else if (!tableData || tableData.length < 1) {
      errors.tableData = "Please fill  First Party";
    } else if (!witnessTableData || witnessTableData.length === 1) {
      errors.witnessTableData = "Please fill atleast two  Witness";
    }

    // If there are errors, set validation state and show first error message
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      toast.error(Object.values(errors)[0]); // Show only the first error
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();

      // Helper to format party data as required
      const formatPartyData = (partyData) =>
        partyData
          .map(
            (entry) =>
              `${entry.id}~${entry.Name}~${entry.relativeName}~${entry.address}~${entry.occupation}~${entry.relation}`
          )
          .join("#"); // Join entries with '|' as a separator if multiple records

      // Format prt2name data
      const firstPartyFormatted = formatPartyData(tableData);
      const witnessFormatted = formatPartyData(witnessTableData);

      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_attendence",
        tokenno: formData2.option,
        misc_fee: formData2.fee,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "string",
        nakalcopy: "0",
        mode: "string",
        prtname: formData2.prtname,
        prt2name: `${firstPartyFormatted}#${witnessFormatted}#`,
        property_detail: "",
      };

      // Append payload data to FormData
      Object.keys(payload).forEach((key) => {
        formData.append(key, payload[key]);
      });

      console.log("FormData payload:", Object.fromEntries(formData.entries())); // Debug

      // API call
      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Insert_Cashreceipt_Sp`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      debugger;
      if (response.status === 200 && response.data) {
        console.log("API Response:", response.data);
        dispatch(resetPartyDetails());
        setTableData([]);
        setWitnessTableData([]);
        setFee("");
        // sessionStorage.removeItem("firstPartyTableData", JSON.stringify(updatedTableData));
        // sessionStorage.removeItem("witnessTableData", JSON.stringify(updatedTableData));
        const printData = response.data.response;
        fetchCashReceiptDetails();
        setLoading(false);
        toast.success("Fees Submitted Successfully");
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        setFormData2({
          prtname: "",
          prt2name: "",
          property_detail: "",
          fee: "",
          option: "",
        });
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      setLoading(false);

      console.error("Error in Insert Search Receipt API:", err);
      alert("Error occurred while saving the receipt.");
    }
  };

  const handleUpdate = async () => {
    debugger;
    try {
      const formData2 = new FormData();
      const payload = {
        dcode: userDetails.dcode,
        srocode: userDetails.srocode,
        pimode: "receipt_attendence",
        tokenno: formData2.option,
        misc_fee: formData2.fee,
        code: selectedYears,
        fyear: fromYear || 0,
        tyear: toYear || 0,
        nakalown: "string",
        nakalregdate: "string",
        nakalcopy: "0",
        mode: "string",
        prtname: formData2.prtname,
        // prt2name: `${firstPartyFormatted}#${witnessFormatted}#`,
        property_detail: "",
        vol: updateCashReceiptDetails?.vol || "",
        sr: updateCashReceiptDetails?.sr || "",
        epayment_rfee: updateCashReceiptDetails?.epayment_rfee || "",
      };

      Object.keys(payload).forEach((key) => {
        formData2.append(key, payload[key]);
      });

      const response = await axios.post(
        `${API_BASE_URL}/CashReceipt/Update_Cashreceipt_Sp`,
        formData2,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        const printData = response.data.response;
        fetchCashReceiptDetails();
        toast.success("Fees Submitted Successfully");

        // Generate the report URL
        const reportUrl = CashReceiptReportLink(
          printData,
          new Date().toISOString().split("T")[0] // Format as YYYY-MM-DD
        );

        // Open report in a new tab
        window.open(reportUrl, "_blank");
        navigate("/ModifyReciept");

        setFormData({
          prtname: "",
          prt2name: "",
          property_detail: "",
        });
      } else {
        throw new Error("Not found");
      }
    } catch (err) {
      console.error("Error in Update Search Receipt API:", err);
      alert("Error occurred while updating the receipt.");
    }
  };

  const relationData = [
    { value: "S/O", label: "S/O" },
    { value: "W/O", label: "W/O" },
    { value: "D/O", label: "D/O" },
    { value: "C/O", label: "C/O" },
    { value: "MALE", label: "MALE" },
    { value: "FEMALE", label: "FEMALE" },
  ];

  const occupationData = [
    { value: "सर्विस", label: "सर्विस" },
    { value: "ग्रहणी", label: "ग्रहणी" },
    { value: "खेती", label: "खेती" },
    { value: "मज़दूरी", label: "मज़दूरी" },
    { value: "कातिब", label: "कातिब" },
    { value: "वकील", label: "वकील" },
    { value: "स्टा. विक्रेटा", label: "स्टा. विक्रेटा" },
    { value: "अन्य", label: "अन्य" },
  ];

  return (
    <>
      {loading && (
        <div className="absolute inset-0 bg-gray-500 bg-opacity-10 z-50 flex items-center justify-center">
          <img src={loadercrs} alt="Images" className="w-15 h-15 py-3" />
        </div>
      )}
      <div className="flex h-screen overflow-hidden">
        <SideMenu />
        <div className="flex-1 flex flex-col">
          <div className="shadow-sm">
            <Header />
          </div>

          <div className="flex flex-1 overflow-y-auto scrollbar-hide">
            {/* Left Side */}
            <div className="flex-1 p-1 overflow-y-auto scrollbar-hide">
              <div className="max-w-full mx-auto p-4 bg-secondary-50 rounded-md shadow-md">
                {/* Heading */}
                <h1 className="text-xl md:text-2xl font-semibold mb-6 text-gray-800">
                  New Receipt - Attendance
                </h1>

                {/* Details Section */}
                <div className="mb-6">
                  <div className="flex flex-col md:flex-row gap-2 md:gap-6 flex-wrap">
                    <p>
                      <b>Date:</b>
                      <span>
                        {editMode
                          ? updateCashReceiptDetails.recptDate
                          : currentDate}
                      </span>
                    </p>
                    <p>
                      <b>Vol no:</b>
                      <span>
                        {editMode
                          ? updateCashReceiptDetails.vol
                          : cashReceiptData.vol}
                      </span>
                    </p>
                    <p>
                      <b>Application no:</b>
                      <span>
                        {editMode
                          ? updateCashReceiptDetails.srno
                          : cashReceiptData.srno}
                      </span>
                    </p>
                    <p>
                      <b>Crt no:</b>
                      <span>
                        {editMode
                          ? updateCashReceiptDetails.appliNo
                          : cashReceiptData.applino}
                      </span>
                    </p>
                    <p>
                      <b>Fee:</b>
                      <span>
                        {editMode ? updateCashReceiptDetails.miscFee : fee}
                      </span>
                    </p>
                  </div>
                </div>

                {/* Radio Buttons */}
                <div className="flex flex-col md:flex-row items-center mb-6 gap-4 md:gap-8">
                  <div className="flex items-center gap-2">
                    <input
                      id="default-radio-1"
                      type="radio"
                      name="default-radio"
                      value="Attendance"
                      checked={formData2.option === "Attendance"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-2 focus:ring-blue-500"
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="text-sm font-medium text-gray-900"
                    >
                      Attendance
                    </label>
                  </div>
                  <div className="flex items-center gap-2">
                    <input
                      id="default-radio-2"
                      type="radio"
                      name="default-radio"
                      value="Objection"
                      checked={formData2.option === "Objection"}
                      onChange={handleRadioChange}
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-2 focus:ring-blue-500"
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="text-sm font-medium text-gray-900"
                    >
                      Objection
                    </label>
                  </div>
                </div>

                {/* Applicant Input */}
                <div className="md:w-1/3 w-full mb-4">
                  <div className="relative">
                    <input
                      id="prtname"
                      type="text"
                      value={formData2.prtname}
                      onChange={handleChanges}
                      className={`w-full border ${
                        validationErrors.prtname
                          ? "border-[#DA0000]"
                          : "border-[#B1B1B1]"
                      } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      placeholder=""
                    />
                    <label
                      htmlFor="prtname"
                      className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                    >
                      Applicant Name
                    </label>
                  </div>
                </div>
                <div className="md:w-1/3 w-full mb-4">
                  <div className="relative">
                    <input
                      id="fee"
                      type="number"
                      value={formData2.fee}
                      onChange={handleChanges}
                      className={`w-full border ${
                        validationErrors.fee
                          ? "border-[#DA0000]"
                          : "border-[#B1B1B1]"
                      } p-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 peer`}
                      placeholder=""
                    />
                    <label
                      htmlFor="fee"
                      className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                    >
                      Fee
                    </label>
                  </div>
                </div>

                {/* Toggle Buttons */}
                <div className="flex flex-col md:flex-row gap-4 mb-6">
                  <button
                    onClick={() => handleFormToggle("firstParty")}
                    className={`px-6 py-2 rounded shadow ${
                      activeForm === "firstParty"
                        ? "bg-black text-white hover:bg-blue-600"
                        : "bg-gray-200 text-gray-600 hover:bg-gray-300"
                    }`}
                  >
                    First Party
                  </button>
                  <button
                    onClick={() => handleFormToggle("witness")}
                    className={`px-6 py-2 rounded shadow ${
                      activeForm === "witness"
                        ? "bg-black text-white hover:bg-blue-600"
                        : "bg-gray-200 text-gray-600 hover:bg-gray-300"
                    }`}
                  >
                    Witness
                  </button>
                </div>

                {/* Form Content */}

                <form onSubmit={handleAdd}>
                  <div>
                    <h3 className="mb-4 text-lg md:text-xl font-bold">
                      {activeForm === "firstParty"
                        ? "First Party Form"
                        : "Witness Form"}
                    </h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-8 gap-4 mb-4">
                      {[
                        "Name",
                        "relation",
                        "relativeName",
                        "occupation",
                        "address",
                      ].map((field) => (
                        <div
                          key={field}
                          className={`relative col-span-1 md:col-span-4 ${
                            ["address"].includes(field)
                              ? "lg:col-span-4"
                              : "lg:col-span-2"
                          }`}
                        >
                          {field === "relation" || field === "occupation" ? (
                            <select
                              id={field}
                              value={
                                activeForm === "firstParty"
                                  ? formData[field]
                                  : witnessFormData[field]
                              }
                              onChange={(e) => handleChange(e)}
                              name={field}
                              className={`w-full border ${
                                validationErrors[field]
                                  ? "border-[#DA0000]"
                                  : "border-[#B1B1B1]"
                              } rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400`}
                            >
                              <option value="" disabled>
                                Select {field}
                              </option>
                              {(field === "relation"
                                ? relationData
                                : occupationData
                              ).map((option) => (
                                <option key={option.value} value={option.value}>
                                  {option.label}
                                </option>
                              ))}
                            </select>
                          ) : (
                            <input
                              id={field}
                              type="text"
                              value={
                                activeForm === "firstParty"
                                  ? formData[field]
                                  : witnessFormData[field]
                              }
                              onChange={(e) => handleChange(e)}
                              placeholder=" "
                              className={`w-full border ${
                                validationErrors[field]
                                  ? "border-[#DA0000]"
                                  : "border-[#B1B1B1]"
                              } rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 peer`}
                              name={field}
                            />
                          )}
                          <label
                            htmlFor={field}
                            className="absolute text-sm text-gray-500 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2 peer-focus:text-blue-600 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 start-1"
                          >
                            {field}
                          </label>
                          {/* {validationErrors[field] && (
            <p className="text-[#DA0000] text-sm mt-1">{validationErrors[field]}</p>
          )} */}
                        </div>
                      ))}
                      {["Add", "Modify", "Next"].map((text, index) => (
                        <div
                          key={text}
                          className={
                            index === 2
                              ? "col-span-1 md:col-span-1 md:col-end-9"
                              : "col-span-1"
                          }
                        >
                          <button className="w-full px-2 py-2 bg-blue-500 text-white rounded shadow hover:bg-blue-600">
                            {text}
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </form>
                {/* Table Section */}

                {activeForm === "firstParty" && (
                  <table>
                    <thead>
                      <tr>
                        <th className="border border-gray-300 px-4 py-2">
                          Applicant Name
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Relation
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Relative Name
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Address
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Occupation
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((entry) => (
                        <tr key={entry.id}>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.Name}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.relation}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.relativeName}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.address}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.occupation}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 flex gap-2 justify-center">
                            <button
                              onClick={() => handleEdit(entry.id)}
                              className="text-[#3973f1] hover:underline"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleDelete(entry.id)}
                              className="text-[#FE0004] hover:underline"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {activeForm === "witness" && (
                  <table>
                    <thead>
                      <tr>
                        <th className="border border-gray-300 px-4 py-2">
                          Applicant Name
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Relation
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Relative Name
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Address
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Occupation
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {witnessTableData.map((entry) => (
                        <tr key={entry.id}>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.Name}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.relation}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.relativeName}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.address}
                          </td>
                          <td className="border border-gray-300 px-4 py-2">
                            {entry.occupation}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 flex gap-2 justify-center">
                            <button
                              onClick={() => handleEdit(entry.id)}
                              className="text-[#3973f1] hover:underline"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleDelete(entry.id)}
                              className="text-[#FE0004] hover:underline"
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}

                {/* Footer Buttons */}
                <div className="flex flex-col md:flex-row items-center justify-center gap-4 p-2">
                  <button
                    onClick={editMode ? handleUpdate : handleSave}
                    className="bg-blue-400 text-white w-full md:w-auto px-6 py-3 rounded shadow"
                  >
                    {editMode ? "UPDATE" : "SAVE"}
                  </button>
                  <button className="w-full md:w-auto px-6 py-3 bg-red-500 text-white rounded shadow hover:bg-red-600">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            {/* Right Side */}
            <div className="w-64 overflow-y-auto scrollbar-hide">
              <UserMenu />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NewReceipt;
